import { DiscountChip } from '~/entities/BookingCar'
import { BookingCarAttributes, BookingCarDiscount } from '~/shared/api'
import { CURRENCY } from '~/shared/config/constants'
import { Characteristics } from './Characteristics'
import {
  Title,
  Wrapper,
  Price,
  DescriptionWrapper,
  ImageWrapper,
  Img,
  Chip,
} from './styled'

type CardProps = {
  carId: UniqueId
  carAttributes: BookingCarAttributes
  xTaxiparkKey?: UniqueId
  taxiparkName?: string
  discount?: BookingCarDiscount
}

export function Card({
  carId,
  carAttributes,
  xTaxiparkKey,
  taxiparkName,
  discount,
}: CardProps) {
  const photo = carAttributes.photos?.[0]

  const to = `${carId}${xTaxiparkKey ? `?xTaxiparkKey=${xTaxiparkKey}` : ''}`

  return (
    <Wrapper to={to} data-testid={`booking-car-${carAttributes.plateNumber}`}>
      <ImageWrapper>
        {carAttributes?.isLeasingFullyPaid && <Chip>Возможен выкуп</Chip>}
        {discount && (
          <DiscountChip
            discount={discount}
            pricePerDay={carAttributes.pricePerDay}
          />
        )}
        {taxiparkName && (
          <Chip
            style={{
              top: carAttributes?.isLeasingFullyPaid ? '46px' : '12px',
            }}
          >
            {taxiparkName}
          </Chip>
        )}
        <Img src={photo} alt='booking-car-photo' />
      </ImageWrapper>

      <DescriptionWrapper>
        <Title>
          {carAttributes?.brand} {carAttributes?.model}
        </Title>

        <Characteristics carAttributes={carAttributes} />

        <Price>
          {carAttributes.pricePerDay?.toLocaleString()} {CURRENCY} / сутки
        </Price>
      </DescriptionWrapper>
    </Wrapper>
  )
}
